import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  feedbacks: [],
  isLoading: false,
  error: null,
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setFeedbacks: (state, action) => {
      state.feedbacks = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setFeedbackLoading: (state, action) => {
      state.isLoading = action.payload;
      state.error = null;
    },
    setFeedbackError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    updateFeedbackStatus: (state, action) => {
      const updatedFeedback = action.payload;
      const index = state.feedbacks.findIndex(
        (f) => f._id === updatedFeedback._id
      );
      if (index !== -1) {
        const previousUser = state.feedbacks[index].user;
        state.feedbacks[index] = {
          ...state.feedbacks[index],
          ...updatedFeedback,
          user: previousUser,
        };
      }
    },
  },
});

export const {
  setFeedbacks,
  setFeedbackLoading,
  setFeedbackError,
  updateFeedbackStatus,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
